// extracted by mini-css-extract-plugin
module.exports = {"variant":"ProductVariant_variant__JVeu4"};